import { EMS_ENVIRONMENT } from 'tools/utils/libs/helper';

// 授信环节接口的统一路径（所有API的第一个词） 开发环境不过网关 统一都是空字符串；测试和线上环境会过网关三个环节分别是不同的词
// export const isDev = process.env.NODE_ENV === 'development';
// 统一处理环境变量，以便和setupProxy里的代理地址保持统一,若不想保持一致，可以使用上面的方式进行判断
const isDev = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_IS_DEBUG === 'true' : false;

const getGatewayPrefix = (prefix: string): string => {
    return isDev ? '' : `/${prefix}`;
}

const CREDIT_API = getGatewayPrefix('credit');
// 用信环节接口的统一路径
const LOAN_API = getGatewayPrefix('withdraw');
// 用信、授信、还款首页
const CONVENIENT_API = getGatewayPrefix('convenient');
// 换绑卡功能
const BINDCARD_API = getGatewayPrefix('bindingcard');
// 还款环节接口的统一路径
const REPAY_API = getGatewayPrefix('repay');
// abtest的网关
const AB_API = getGatewayPrefix('ab');
// h5人脸认证网关
const H5FACE_API = getGatewayPrefix('authcomponent');
// 平台banner的网关
const LOANPORTAL_API = getGatewayPrefix('loanportal');
// 许愿池的网关
const WISH = getGatewayPrefix('quota');
// 新客活动网关
const NEW_LOAN = getGatewayPrefix('activity');
// 提额网关
const Withdrawal = getGatewayPrefix('creditkeeper');
// 授信api
const CREDIT_KEEPER= getGatewayPrefix('creditkeeper');
// 微信网关
const WeChat = getGatewayPrefix('wechat');

const ApiMapV2 = {
    // 获取ems静态资源
    getEMSData: `${EMS_ENVIRONMENT}/api/ems/get/data`,
    // 人脸
    // face三合一初始化接口
    faceInit: `${CREDIT_API}/new/face/v1/init`,
    // face三合一提交接口
    faceSubmit: `${CREDIT_API}/new/face/v1/submit`,
    // face失败页初始化接口
    faceFailInit: `${CREDIT_API}/new/face/init/fail`,
    // sdk人脸完成后查询授信状态接口
    faceSdkStatus: `${CREDIT_API}/audit/v1/apply/result`,
    // 用信face接口
    faceInitWithDraw: `${LOAN_API}/v2/supply/record/face/init`,
    faceSubmitWithDraw: `${LOAN_API}/v2/supply/record/face/submit`,
    // 新sdk授信初始化
    newFaceAccreditInit: `${CREDIT_API}/new/face/v2/init`,
    // 新sdk用信初始化
    newFaceWithdrawInit: `${LOAN_API}/v3/supply/record/getRealnameInfo`,
    // 新sdk授信获取人脸结果
    queryNewFaceAccreditResult: `${CREDIT_API}/new/face/v2/submit`,
    // 新sdk用信获取人脸结果
    queryNewFaceWithdrawResult: `${LOAN_API}/v3/supply/record/face/checkResult`,
    // 授信
    // 获取用户姓名身份证信息
    getUserIdNumber: `${CREDIT_API}/auth/v1/init`,
    // 用户点击返回挽留弹窗弹出后通知后端记录数据 一天弹一次
    saveRecord: `${CREDIT_API}/auth/v1/saveRecord`,
    // 授信上传ocr照片
    creditUploadOcr: `${CREDIT_API}/auth/v2/upload`,
    // 提交用户姓名身份证信息
    postUserIdNumberV1: `${CREDIT_API}/auth/v1/save`,
    //授信验二提交-实验组
    postIdCardInfo: `${CREDIT_API}/auth/v1/saveIdentityCard`,
    //  获取人行征信授权类型，小贷还是融担
    getInvestigationType: `${CREDIT_API}/auth/v2/investigationType`,
    // 小微获取人行征信授权类型，小贷还是融担
    getXiaoweiInvestigationType: `${CREDIT_API}/auth/getInvestigationV3Type`,
    //授信中免息券挽留弹框展示通知后端
    callBackPop: `${CREDIT_API}/auth/v1/popupCallBack`,

    // 征信授权 初始化接口
    agreementAuthInit: `${CREDIT_API}/agreement/auth/init`,
    // 征信授权 签署协议接口
    agreementAuthSubmit: `${CREDIT_API}/authorize/v3/sign`,

    // 授信审核中页面初始化
    auditingInit: `${CREDIT_API}/audit/v3/wait`,
    // 授信审核失败
    auditFailedInitV4: `${CREDIT_API}/audit/v4/not/pass`,
    // 授信审核成功页初始化
    auditSuccessInit: `${CREDIT_API}/audit/get/limit`,
    // 信用飞授信审核中页面初始化
    xyfAuditingInit: `${CREDIT_API}/audit/xyf/wait`,
    // 信用飞授信补充信息页
    verifyXYFBaseInfo: `${CREDIT_API}/add/verify/init`,
    // 信用飞授信补充信息提交
    saveVerifyXYFinfo: `${CREDIT_API}/add/verify/save`,
    // 获取信用飞授信协议列表
    getXYFContract: `${CREDIT_API}/contract/info`,

    // 查询审核结果
    auditStatus: `${CREDIT_API}/audit/v3/result`,
    // 首页
    homeInit: `${CONVENIENT_API}/v2/home`,
    homeInitV3: `${CONVENIENT_API}/v3/home`,
    repayList: `${CONVENIENT_API}/v1/repayList`,
    recreateOrder: `${CONVENIENT_API}/v2/recreate/credit`,
    applyTempQuota: `${CREDIT_KEEPER}/adjustQuotaPrice/applyTempQuota`,
    saveAgreementLog: `${CONVENIENT_API}/v2/saveAgreementLog`,
    whiteList: `${CONVENIENT_API}/v1/whiteness`,
    borrowCheck: `${CONVENIENT_API}/v2/borrow/check`,
    createCredit: `${CONVENIENT_API}/v1/create/credit`,
    followServiceAccount: `${CONVENIENT_API}/service/follow`,
    // 登录成功后看跳转到那个页面 老系统的立即申请、首页还是新系统的首页
    getPageUrl: `${CONVENIENT_API}/route/init`,
    // 记录会员弹窗次数（首页）
    getVipPopNumber: `${CONVENIENT_API}/save/userMemberPop`,
    //领取免息券
    getFreeCoupon: `${CONVENIENT_API}/coupon/sendNewCustomer`,
    //新授信 ocr识别json上报，用信也使用
    uploadOcr: `${CREDIT_API}/auth/native/upload`,

    // 用信
    // 提现页面第一次进来初始化
    loanInitBase: `${LOAN_API}/loan/v3/initBaseInfo`,
    // 提现页面 路由加试算
    loanRouteTrail: `${LOAN_API}/loan/routeAndTrial`,
    // 这个是 不选择担保服务没资方 选择担保服务才有资方的路由试算接口  为了本地联调多个场景用的
    loanRouteTrailFailed: `${LOAN_API}/loan/routeTrailFailed`,
    //关闭待增验的订单
    closeorder: `${LOAN_API}/loan/v1/closeOrder`,
    // 提现页面获取借款用途列表
    getUsageList: `${LOAN_API}/basedata/v2/loan/use`,
    // 提现页面获取还款来源列表
    getRepayFromList: `${LOAN_API}/basedata/loan/getSupplyFromList`,
    // 提现页面 确认借款按钮 提交数据
    loanSubmitV5: `${LOAN_API}/loan/v5/submit`,
    // 发送短信验证码
    msgSendV2: `${LOAN_API}/msg/v2/send`,
    // 长银-预绑卡
    changyinMsgSend: `${LOAN_API}/card/v1/preBindCard`,
    // 提现页面 校验短信验证码
    verifyMsgV4: `${LOAN_API}/msg/v4/verify`,
    // 桔多多二次绑卡接口
    confirmBindCard: `${LOAN_API}/card/v1/confirmbindcard`,
    // 获取合同列表
    getfundsContractList: `${LOAN_API}/v1/contract/loan/contract/list/all`,
    // 获取相关协议列表
    getOtherAgreementList: `${LOAN_API}/contract/loan/list/all`,
    // 获取资方授信合同详情
    getContractDetail: `${LOAN_API}/contract/fund/credit`,
    // 提现页会员卡弹框信息
    getPrivilegeInfo: `${LOAN_API}/member/privilegeInfoV2`,
    // 提现页会员卡弹框点击支付按钮
    buyVip: `${LOAN_API}/member/open/membershipV2`,
    // 提现页会员卡购买成功后第一次跳回的弹框
    getCouponList: `${LOAN_API}/member/couponList`,
    // 提现页会员卡购买成功后 领取优惠券
    receiveCoupon: `${LOAN_API}/member/receiveMembers`,
    // 资金匹配卡详情页
    getCardDetail: `${LOAN_API}/member/fundMatchCardInfo`,

    // 首页换绑卡html预览接口
    homeContractLoan: `${BINDCARD_API}/card/contract/view`,
    // 放款换绑卡的html预览接口
    loanContractLoan: `${LOAN_API}/contract/business/view`,
    // 蓝海合同html预览接口
    contractDetail: `${LOAN_API}/contract/all/view`,
    // 获取某一资方的合同列表
    getContractList: `${LOAN_API}/contract/loan/contract/list/config`,
    // 增验 - 列表
    verifyList: `${LOAN_API}/v2/supply/record/list`,
    // 增验 - 列表V3
    verifyListV3: `${LOAN_API}/v3/supply/record/list`,
    // 增验 - 迭代V3 - 提交确认
    loanConfirmV3: `${LOAN_API}/v3/supply/record/submit`,
    // 增验 - 紧急联系人信息回显
    emergencyInfo: `${LOAN_API}/v2/supply/record/contact/query`,
    // 增验 - 紧急联系人提交
    emergencySubmit: `${LOAN_API}/v2/supply/record/contact/save`,
    // 增验 - 基本信息回显
    verifyBaseInfo: `${LOAN_API}/v2/supply/record/info/get`,
    // 增验 - 基本信息提交
    verifyBaseInfoSubmit: `${LOAN_API}/v2/supply/record/info/save`,
    // 用信 - 审核失败
    loanAuditStatus: `${LOAN_API}/loan/page/button`,
    // 用信-审核中页面获取审核状态
    loanAuditingStatus: `${LOAN_API}/order/v3/status`,

    // ocr upload
    ocrUploadV3: `${LOAN_API}/v3/supply/record/ocr/upload`,
    // ocr submit
    ocrSubmitV3: `${LOAN_API}/v3/supply/record/ocr/submit`,
    ocrVerifySubmit: `${LOAN_API}/v3/supply/record/new/ocr/submit`,
    // 中关村资方信息认证链接获取
    getZGCUrl: `${LOAN_API}/v3/supply/record/getZgcContractUrl`,
    // 中关村资方信息认证状态获取
    getZGCStatus: `${LOAN_API}/v3/supply/record/getZgcContractStatus`,
    // 挽留弹框出现  为了用户一天只弹一次
    retainPopupShow: `${LOAN_API}/loan/saveUserRetainPageV2`,
    // 问卷调查 初始化
    initSurvey: `${LOAN_API}/questionnaire/v1/getQuestionnaire`,
    // 问卷调查 初始化
    initNewSurvey: `${LOAN_API}/questionnaire/v2/getQuestionnaire`,
    // 问卷调查 提交
    submitSurvey: `${LOAN_API}/questionnaire/v1/saveUserQuestion`,
    // 获取当前订单绑定手机号和银行卡信息
    getMobileAndBandInfo: `${LOAN_API}/card/v1/getMobileAndBandInfo`,

    /**
     * 获取是否弹挽留弹窗
     * 1:用信挽留弹窗;2:首次用信且有新客优惠券挽留弹窗;3:未填写借款金额且客户有可用优惠券挽留弹窗;
     * 4:未填写借款金额且客户发生降价挽留弹窗;5:已填写借款金额且客户未绑卡且当前资方支持免卡号绑卡挽留弹窗;
     * 6:已填写借款金额且客户未绑卡且当前资方不支持免卡号绑卡挽留弹窗;
     * 7:增验流程中退出，包含人脸页面、身份证上传页面、基本信息页面挽留弹窗;
     */
    getRetainPage: `${LOAN_API}/loan/queryUserRetainPage`,

    // 还款接口
    // 获取按期还款还款详情
    getTermDetail: `${REPAY_API}/v2/term/detail`,
    // 查询提前结清还款详情
    getAllDetail: `${REPAY_API}/v2/advance/detail`,
    // 还款详情初始化接口 多借据
    getDetail: `${REPAY_API}/v1/repay/plan`,
    // 获取借款用途证明图片
    getLaonUseDetail: `${REPAY_API}/purpose/list`,
    // 添加借款用途
    addLaonUseDetail: `${REPAY_API}/purpose/add`,

    // 获取到上报给wmda公共参数的接口
    abtest: `${AB_API}/value/layer`,
    // 获取实验组具体是a还是b
    getABvalue: `${AB_API}/abtest/value`,

    testAB: `${AB_API}/abtest/value`,
    //新策略决策借口，多实验id 时，通过实验层 id 获取配置实验id
    newTestAB: `${AB_API}/path/newfe`,

    // forceContract: `${LOAN_API}/contract/loan/forceContract/view`,  锁期换成contractDetail接口了  稳定了再删除

    // 绑卡服务接口
    // 获取银行卡列表
    getBankCardList: `${BINDCARD_API}/bindcard/boundCards`,
    // 设置默认银行卡
    setDefaultCard: `${BINDCARD_API}/bindcard/v2/setDefaultCard`,
    // 支持银行卡列表
    supportBank: `${BINDCARD_API}/bindcard/supportBankGroup`,
    // 添加银行卡页面初始化
    bankCardAddInit: `${BINDCARD_API}/bindcard/pageInit`,
    // 添加银行卡页面 获取银行卡信息
    getBankCardInfo: `${BINDCARD_API}/bindcard/cardInfo`,
    // face++银行卡OCR识别接口
    getBankCardInfoOCR: `${LOAN_API}/card/v1/bankOcrInfo`,
    // 预绑卡
    preBindCard: `${BINDCARD_API}/bindcard/prebind`,
    // 确认绑卡
    bindCard: `${BINDCARD_API}/bindcard/v2/confirm`,
    // 绑卡协议预览
    addBankCardProtocol: `${BINDCARD_API}/bindcard/contractPreView`,
    // 免验绑卡
    bindCardNoVerify: `${BINDCARD_API}/bindcard/v1/noVerifyBindCard`,
    // 重新预绑卡
    preRebindCard: `${BINDCARD_API}/bindcard/preRebindCard`,
    // 重新确认绑卡
    confirmRebindCard: `${BINDCARD_API}/bindcard/confirmRebindCard`,

    // 人脸认证获取token
    getToken: `${H5FACE_API}/face/getToken`,

    // 征信异议申请信息提交
    submitObjection: `${CREDIT_API}/complain/submit`,

    // 提额许愿池
    getActivityTime: `${WISH}/credit/v1/getActivityTime`,
    //  是否为目标用户，并获取用户信息
    isJudgeUserInfo: `${WISH}/credit/v1/isJudgeUserInfo`,
    //  发起许愿
    makeWish: `${WISH}/credit/v1/makeWish`,
    // 带微信服务号banner
    getBanner: `${LOANPORTAL_API}/common/banner/query`,

    // 实名认证ab测
    abTestIDCard: `${CREDIT_API}/auth/v1/abTest`,
    // 新客活动页查询接口
    getTicketStatus: `${NEW_LOAN}/active/index`,
    // 领取新人专享卡卷
    getExclusiveCoupon: `${NEW_LOAN}/active/getExclusiveCoupon`,

    // 获取支持免卡号绑卡的银行信息
    getSupportBankInfo: `${BINDCARD_API}/nocardnumber/getSupportBankInfo`,
    // 预绑卡接口
    prebind: `${BINDCARD_API}/nocardnumber/prebind`,
    // 查询绑卡结果
    getNoCardBindCardResult: `${BINDCARD_API}/nocardnumber/getNoCardBindCardResult`,
    // 获取免卡号绑卡的协议
    getContractInfo: `${BINDCARD_API}/nocardnumber/getMobileAndContractInfo`,
    // 无卡号绑卡合同预览
    contractPreView: `${BINDCARD_API}/nocardnumber/contractPreView`,

    //企业认证
    approvedCompany: `${CONVENIENT_API}/user/v1/approvedCompany`,
    //查询调额调价结果
    queryApplyResult: `${CONVENIENT_API}/user/v1/queryApplyResult`,
    //图片鉴权
    imgAuth: `${CREDIT_API}/auth/v1/imageUrlEncrypt`,
    //小微认证状态
    xwStatus: `${CONVENIENT_API}/user/v1/getXiaoWeiAuthStatus`,
    //获取企业信息列表
    queryCompanyList: `${CONVENIENT_API}/user/v1/getCompanyInfoList`,

    //获取个税、公积金状态
    getAuthStatus: `${Withdrawal}/auth/getAuthRecordStatusByType`,
    //个税、公积金认证申请
    applySubmit: `${Withdrawal}/adjustQuotaPrice/authApply`,
    //获取认证状态
    getSerialNoStatus: `${Withdrawal}/auth/getAuthRecordStatusBySerialNo`,
    //获取历史记录
    getHistory: `${Withdrawal}/adjustQuotaPrice/getHistory`,
    //获取认证入口页文案
    getAuthEnterPage: `${Withdrawal}/page/getAuthEnterPage`,

    // 获取微信初始化
    getWXConfig: `${WeChat}/api/share/get`,
    
    // 获取Wos签名Token
    getWosToken: `/creditloan/getToken`,
};

export default ApiMapV2;
